type CasteRow = {
    level?: number;
    display?: string;
    voters?: number | string;
    voters_percent?: number | string;
};

type Props = { rows: unknown };

export default function DataBankOverallCasteTable({ rows }: Props) {
    const safeRows = Array.isArray(rows) ? (rows as CasteRow[]) : [];
    if (!safeRows.length) {
        return <p className="text-sm text-gray-600">Caste data not available.</p>;
    }
    return (
        <table className="fsd-caste-details w-full">
            <thead>
                <tr className="bg-gray-200 font-bold">
                    <th className="first text-left">Caste</th>
                    <th className="second text-right">Voters</th>
                    <th className="third text-right">Voters %</th>
                </tr>
            </thead>
            <tbody>
                {safeRows.map((row, i) => (
                    <tr key={`${row.display ?? i}`} className={`level-${row.level ?? 0}`}>
                        <td className="first text-left">{row.display ?? "—"}</td>
                        <td className="second text-right">{row.voters ?? "—"}</td>
                        <td className="third text-right">{row.voters_percent ?? "—"}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
